import type { PagedResultDto } from "@services/dto/pagedResultDto"
import promotionProgramService from "@services/promotionProgram/promotionProgramService"
import { action, makeAutoObservable, observable } from "mobx"

class PromotionProgramStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable listPromotion!: any

  @observable specialPromotionPrograms!: PagedResultDto<any>
  @observable specialPromotionDetail!: any
  @observable listSpecialPromotion!: any
  constructor() {
    makeAutoObservable(this)

    this.tableData = { items: [], totalCount: 0 }
    this.detailData = {}
    this.listPromotion = []

    this.specialPromotionPrograms = { items: [], totalCount: 0 }
    this.specialPromotionDetail = {}
    this.listSpecialPromotion = []
  }

  @action
  async createOrUpdate(body: any) {
    const result = await promotionProgramService.createOrUpdate(body)
    if (!body.id) {
      this.detailData = result
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
  }

  @action
  async createOrUpdateSpecial(body: any) {
    const result = await promotionProgramService.createOrUpdateSpecial(body)
    if (!body.id) {
      this.specialPromotionDetail = result
      this.specialPromotionPrograms.items.push(result)
    } else {
      this.specialPromotionPrograms.items =
        this.specialPromotionPrograms.items.map((x) => {
          if (x.id === body.id) x = result
          return x
        })
    }
  }

  @action
  async newDetail() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    await promotionProgramService.active(id, isActive)
  }

  @action
  async activeSpecial(id: number, isActive) {
    await promotionProgramService.activeSpecial(id, isActive)
  }

  @action
  async bulkActive(id: number[]) {
    await promotionProgramService.bulkActive(id)
  }
  @action
  async get(id: number) {
    const result = await promotionProgramService.get(id)
    this.detailData = result
  }

  @action
  async getSpecial(id: number) {
    const result = await promotionProgramService.getSpecial(id)
    this.specialPromotionDetail = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await promotionProgramService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async getAllSpecial(params: any) {
    this.isLoading = true
    const result = await promotionProgramService
      .getAllSpecial(params)
      .finally(() => (this.isLoading = false))
    this.specialPromotionPrograms = result
  }

  @action
  async getList() {
    this.isLoading = true
    const result = await promotionProgramService
      .getList()
      .finally(() => (this.isLoading = false))
    this.listPromotion = result
  }

  @action
  async getListSpecial() {
    this.isLoading = true
    const result = await promotionProgramService
      .getListSpecial()
      .finally(() => (this.isLoading = false))
    this.listSpecialPromotion = result
  }

  @action
  async importPromotionProgram(file: File) {
    this.isLoading = true
    try {
      return await promotionProgramService.importPromotionProgram(file)
    } finally {
      this.isLoading = false
    }
  }

  @action
  async downloadPromotionProgramTemplate() {
    await promotionProgramService.downloadPromotionProgramTemplate()
  }
}

export default PromotionProgramStore
